import { countAllFilters } from 'src/filters/countAllFilters';
import { RootState } from 'src/store';

export const selectSchedulePage = (state: RootState) => state.schedulePage.page;
export const selectScheduleQueryString = (state: RootState) => state.schedulePage.query;
export const selectScheduleFilters = (state: RootState) => state.schedulePage.filters;
export const selectScheduleFiltersCount = (state: RootState) =>
  countAllFilters(state.schedulePage.filters);
export const selectShowInactiveSchedule = (state: RootState) => state.schedulePage.showInactive;
